function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zM6.833 5.418A13.946 13.946 0 0 1 16 2c7.732 0 14 6.268 14 14 0 3.506-1.289 6.711-3.418 9.167L6.831 5.42zM5.419 6.833A13.946 13.946 0 0 0 2 16c0 7.732 6.268 14 14 14 3.506 0 6.711-1.289 9.167-3.419L5.42 6.833z"
});

var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "4febf1e3d683ce2a31bd530d20415523.svg";
export { SvgCancel as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/cancel.svg
// module id = null
// module chunks = 